import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Chip
} from '@mui/material';
import {
  Warning as WarningIcon,
  AccessTime as TimeIcon
} from '@mui/icons-material';

interface DelayAlertsProps {
  alerts: Array<{
    appointmentId: string;
    animalName: string;
    ownerName: string;
    scheduledAt: string;
    arrivedAt: string;
    waitingMinutes: number;
  }>;
}

export const DelayAlerts: React.FC<DelayAlertsProps> = ({ alerts }) => {
  if (alerts.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        avatar={<WarningIcon color="warning" />}
        title="Alerte intarzieri"
        subheader={`${alerts.length} pacient(i) asteapta peste limita`}
      />
      <CardContent>
        <List dense>
          {alerts.map((alert) => (
            <ListItem key={alert.appointmentId}>
              <ListItemIcon>
                <TimeIcon color="warning" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2">
                    {alert.animalName} - {alert.ownerName}
                  </Typography>
                }
                secondary={`Asteapta de ${alert.waitingMinutes} minute`}
              />
              <Chip
                label={`${alert.waitingMinutes} min`}
                color="warning"
                size="small"
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

